@if (chargingStations.length > 0) {
  <div>
    <h5 translate="services.chargingStations.cockpitTitle"></h5>
    <div class="d-table w-100">
      @for (station of chargingStations; track station) {
        <div class="d-table-row">
          <div class="d-table-cell">
            <p><strong>{{ station['name' + crtLang.toUpperCase()] }}</strong></p>
          </div>
          <div class="d-table-cell">
            @if (station.numberOfEvse > 0) {
              <p>
                <span translate="services.chargingStations.numberOfEvse"
                  [translateParams]="{ nbFree: station.numberOfFreeEvse, nbEvse: station.numberOfEvse }">
                </span>
                <fa-icon class="ms-2"
                  [icon]="icons.info"
                [ngbPopover]="popoverTemplate" data-bs-trigger="hover focus"></fa-icon>
              </p>
            }
            @if (station.numberOfEvse === 0) {
              <p translate="common.unknown"></p>
            }
            <ng-template #popoverTemplate>
              @for (status of station.evseStatuses | keyvalue; track status) {
                <p>
                  <span class="dot gray-border"
                              [ngClass]="{
                                'green': status.value === ChargingStationEvseStatus.Free,
                                'red': status.value === ChargingStationEvseStatus.Error,
                                'yellow': status.value === ChargingStationEvseStatus.Occupied,
                                'gray': status.value === ChargingStationEvseStatus.Unknown }">
                  </span>
                  {{ 'services.chargingStations.plug' | translate }}
                  {{ ' ' + status.key + ': ' }}
                  {{ 'common.evseStatus.' + status.value | translate }}
                </p>
              }
            </ng-template>
          </div>
          @if (isExploitant) {
            <div class="d-table-cell">
              <div ngbDropdown>
                <button class="btn btn-outline-secondary" translate="services.chargingStations.liberatePlug"
                  type="button"
                ngbDropdownToggle></button>
                <div ngbDropdownMenu>
                  @for (status of station.evseStatuses | keyvalue; track status) {
                    <div>
                      <button ngbDropdownItem
                        (click)="freePlug(station.id, status.key)">
                        {{ status.key }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    @if (chargingStations.length === 0) {
      <div>
        <p translate="services.chargingStations.noDataAvailable"></p>
      </div>
    }
  </div>
}



